let jsToKotlin = new Map([
  ["string", "String"],
  ["number", "Int"],
  ["boolean", "Boolean"]
]);

export const toKotlinType = (value: string) => {
  return jsToKotlin.get(value.toLowerCase()) || value;
};
